import { cronHttp } from "api/cronHttp";
import { http } from "api/http";

const getServices = ({ queryKey }) => {
  return http.get("/services", { params: { ...queryKey[1] } });
};

const getServicesexport = (data) => {
  return cronHttp.post("/services/services-export", data);
};

const getDefaultServices = ({ queryKey }) => {
  return http.get("/services/default", { params: { ...queryKey[1] } });
};

const importServices = (data: any) => {
  return http.post("/services/import", data);
};

const getService = ({ queryKey }: any) => {
  // Pass { original: true } as queryKey[2] to force the SUPER ADMIN original (no org overlay) —
  // used by the super admin portal and the org "super admin view".
  const original = queryKey[2]?.original;
  return http.get(`/services/${queryKey[1]}`, original ? { params: { original: true } } : undefined);
};

const createService = (data: any) => {
  return http.post("/services", data);
};

const updateService = ({ id, data }: any) => {
  return http.put(`/services/${id}`, data);
};

const deleteService = ({ id }: any) => {
  return http.delete(`/services/${id}`);
};

const cloneService = ({ id, data }: any) => {
  return http.post(`/services/${id}/clone`, data);
};

const updateAdminServices = () => {
  return http.post(`/services/update-admin-services`);
};

const getPreferedServices = ({ queryKey }) => {
  return http.get("/services/preferred-services", { params: { ...queryKey[1] } });
};

const bulkDelete = ({ ids }: any) => {
  return http.post(`/services/bulk-delete`, { ids });
};

const bulkClone = ({ ids }: any) => {
  return http.post(`/services/bulk-clone`, { ids });
};

const bulkUpdate = ({ ids, data }: any) => {
  return http.patch(`/services/bulk-update`, { ids, ...data });
};

const servicePreference = ({ id, action }: any) => {
  return http.post(`/services/${id}/preference`, { action });
};

//Service Dashboard
const getServiceAnalytics = ({ queryKey }) => {
  return http.get(`/stats/service-analytics`, { params: { ...queryKey[1] } });
};

//Service Dashboard Table
const getServiceDashboardDetails = ({ queryKey }) => {
  return http.get("/services/dashboard", { params: { ...queryKey[1] } });
};

const getServicesDashboardexport = (data) => {
  return cronHttp.post("/services/servicesdashboard-export", data);
};

const addServiceMileStone = ({ id, data }) => {
  return http.post(`/services/milestone/${id}`, data);
};
const updateServiceMileStone = ({ id, data }) => {
  return http.put(`/services/milestone/${id}`, data);
};

const deleteServiceMileStone = ({ id }) => {
  return http.delete(`/services/milestone/${id}`);
};

const addServiceFavorite = (data) => {
  return http.post(`/services/favorite`, data);
};

const removeServiceFavorite = (data) => {
  return http.post(`/services/remove-favorite`, data);
};

const addComplianceTemplate = (data) => {
  return http.post(`/compliance-templates/`, data);
};

const getComplianceTemplate = ({ queryKey }) => {
  return http.get("/compliance-templates", { params: { ...queryKey[1] } });
};

const getComplianceTemplateAnalytics = ({ queryKey }) => {
  return http.get("/compliance-templates/analytics", { params: { ...queryKey[1] } });
};

const getEditComplianceTemplateAnalytics = ({ queryKey }) => {
  return http.get("/compliance-templates/analytics/edit", { params: { ...queryKey[1] } });
};

const getComplianceTemplateAnalyticsView = ({ queryKey }) => {
  return http.get("/compliance-templates/analytics/view", { params: { ...queryKey[1] } });
};

const getSingleComplianceTemplate = ({ queryKey }) => {
  return http.get(`/compliance-templates/${queryKey[1]}/${queryKey[2]}`);
};

const getSingleComplianceTemplates = ({ queryKey }) => {
  return http.get(`/compliance-templates/services/${queryKey[1]}/${queryKey[2]}`, { params: { ...queryKey[3] } });
};

const updateCompliaceTemplate = ({ id, data }) => {
  return http.put(`/compliance-templates/${id}`, data);
};

const deleteComplianceTemplate = ({ id }: any) => {
  return http.delete(`/compliance-templates/${id}`);
};

const addServicesToTemplate = ({ id, data }: any) => {
  return http.post(`/compliance-templates/add-services-to-template/${id}`, data);
};

const getFilteredServices = ({ queryKey }: any) => {
  return http.get(`/compliance-templates/get-filtered-services`,{ params: { ...queryKey[1] } });
};

const getFilteredServicesInAnalytics = ({ queryKey }: any) => {
  return http.get(`/compliance-templates/analytics/get-filtered-services`,{ params: { ...queryKey[1] } });
};

const deleteServicesToTemplate = ({ id, data }: any) => {
  return http.post(`/compliance-templates/delete-services-to-template/${id}`, data);
};

// Customize a super admin service for the current organization (org-scoped override).
const customizeService = ({ id, data }: any) => {
  return http.put(`/services/${id}/customize`, data);
};

// Restore a customized super admin service back to the super admin default for this org.
const restoreService = ({ id }: any) => {
  return http.delete(`/services/${id}/customize`);
};

export {
  getServicesDashboardexport,
  getServices,
  getServicesexport,
  getDefaultServices,
  importServices,
  createService,
  getService,
  updateService,
  deleteService,
  cloneService,
  updateAdminServices,
  getPreferedServices,
  servicePreference,
  bulkUpdate,
  bulkDelete,
  bulkClone,
  getServiceAnalytics,
  getServiceDashboardDetails,
  addServiceMileStone,
  updateServiceMileStone,
  deleteServiceMileStone,
  addServiceFavorite,
  removeServiceFavorite,
  addComplianceTemplate,
  getComplianceTemplate,
  updateCompliaceTemplate,
  deleteComplianceTemplate,
  getSingleComplianceTemplate,
  getFilteredServices,
  addServicesToTemplate,
  getSingleComplianceTemplates,
  deleteServicesToTemplate,
  getComplianceTemplateAnalytics,
  getFilteredServicesInAnalytics,
  getEditComplianceTemplateAnalytics,
  getComplianceTemplateAnalyticsView,
  customizeService,
  restoreService
};
